import React from 'react'
import PageContent from 'components/common/PageContent'
import StudentCategoriesTable from 'components/organisation/studentCategories/StudentCategoriesTable'

export default function StudentCategories(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "Student Categories"}
    ];

    return (
        <PageContent pathElements={pathElements}>
            <StudentCategoriesTable/>
        </PageContent>
    )
}